import * as React from 'react'

import classNames from 'classnames/bind'

import styles from './index.module.css'

const cx = classNames.bind(styles)
interface Props {
  alignTop?: boolean
  maxWidth?: number
  width?: number
  compact?: boolean
  centered?: boolean
  right?: boolean
  short?: boolean
  wordBreak?: boolean
  overflowFix?: boolean
  colspan?: number
  onClick?: () => void
}

export default function TableBodyCell({
  children,
  alignTop,
  maxWidth,
  width,
  compact,
  centered,
  right,
  short,
  colspan = 1,
  wordBreak = false,
  overflowFix = false,
  onClick,
}: React.PropsWithChildren<Props>) {
  return (
    <td
      style={{
        width,
        maxWidth,
      }}
      className={cx('td', {
        short,
        centered,
        right,
        compact,
        alignTop,
        wordBreak,
        overflowFix,
      })}
      colSpan={colspan}
      onClick={onClick}
    >
      {children}
    </td>
  )
}
